import { STORAGE_KEYS } from 'consts';

export const setRefreshToken = (refreshToken: string) => {
  window.localStorage.setItem(STORAGE_KEYS.refreshToken, refreshToken);
};
